import { render } from "./TardyDetentionCalendar.vue?vue&type=template&id=5be10e64&scoped=true"
import script from "./TardyDetentionCalendar.vue?vue&type=script&lang=js"
export * from "./TardyDetentionCalendar.vue?vue&type=script&lang=js"

import "./TardyDetentionCalendar.vue?vue&type=style&index=0&id=5be10e64&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be10e64"]])

export default __exports__